import { useQuery } from '@tanstack/react-query';
import { fetchVessels } from '@api';
import { useSelector } from 'react-redux';
import { getGeneralSlice } from '@store/features';
import { toast } from 'react-toastify';

export const useLookupVesselsQuery = () => {
  const { segment } = useSelector(getGeneralSlice);
  return useQuery({
    queryKey: ['lookupVessels', segment?.id],
    enabled: !!segment,
    placeholderData: [],
    queryFn: ({ signal }) =>
      fetchVessels(signal, segment.id)
        .then((resp) => resp.assetDetailsList)
        .catch(() => {
          toast.error(`Unable to fetch vessels`, {
            position: 'top-right'
          });
          return [];
        })
  });
};
